import { AnvaPossiblePackage } from '@flows/src/types/anva';
import React, { FC } from 'react';
import {
  HStack,
  VStack,
  Text,
  Radio,
  Table,
  Tbody,
  Tr,
  Td,
  Thead,
  Th,
  Icon,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { toPercentage } from '@sales-conversation/src/utils/stringUtils';

interface Props {
  selectedPackageCode: string | null;
  onPackageSelect: (packageCode: string) => void;
  packageOptions: AnvaPossiblePackage[];
}

const AnvaAddToPackageModalContent: FC<Props> = ({
  selectedPackageCode,
  onPackageSelect,
  packageOptions,
}) => {
  const { t } = useTranslation();

  return (
    <VStack align="stretch" spacing="2">
      {packageOptions.map((pkg) => {
        const isSelected = selectedPackageCode === pkg.code;
        return (
          <VStack
            key={pkg.code}
            spacing="0"
            border="1px"
            borderColor={isSelected ? 'primary.500' : 'gray.100'}
            borderRadius="md"
            onClick={() => onPackageSelect(pkg.code)}
            cursor="pointer"
            _hover={{ borderColor: 'primary.500' }}
            transition="0.2s"
            overflow="hidden"
            align="stretch"
          >
            <HStack p="3" py="4" spacing="2">
              <Radio
                isChecked={isSelected}
                borderColor="gray.200"
                onChange={() => onPackageSelect(pkg.code)}
              />
              <Text textStyle="normalBodyMedium" flexGrow="1">
                {pkg.name}
              </Text>
              <Icon name="GeneralOthersBox" />
            </HStack>
            {pkg.discounts && pkg.discounts.length > 0 && (
              <Table
                overflow="hidden"
                border="none"
                borderTop="1px"
                borderColor="gray.50"
                borderRadius="0"
              >
                <Thead>
                  <Tr>
                    <Th textStyle="smallBody" color="gray.500">
                      {t('FLOW_PRODUCTS_BASKET_PACKAGE_AMOUNT-OF-INSURANCES')}
                    </Th>
                    <Th textStyle="smallBody" color="gray.500">
                      {t('FLOW_PRODUCTS_BASKET_PACKAGE_DISCOUNT')}
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {pkg.discounts.map((discount, i) => (
                    <Tr key={i}>
                      <Td>
                        <Text textStyle="smallBody">
                          {discount.minimum_amount_of_policies}
                        </Text>
                      </Td>
                      <Td>
                        <Text textStyle="smallBody">
                          {toPercentage(discount.percentage / 100, 1)}
                        </Text>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            )}
          </VStack>
        );
      })}
    </VStack>
  );
};

export default AnvaAddToPackageModalContent;
